import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

/**
 * for this page
 */
import SearchNav from './searchNav';
import HeadLine from './headLine';
import Summary from './summary';
import Form from './form';
import Hot from './hot';
import CommentBox from './commentBox';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        surveyData: this.props.content.surveyData,
    };

    render() {
        const { content } = this.props;
        const { search } = content;
        const { surveyData } = this.state;

        // console.log(surveyData);

        return surveyData && surveyData.surveyinfo ? (
            <div className={styles.content}>
                <SearchNav content={{ search, surveyinfo: surveyData.surveyinfo }} />
                <HeadLine content={surveyData.surveyinfo} />
                <Summary content={surveyData.surveyinfo} />
                <div className={styles.main}>
                    <div className={styles.left}>{surveyData.result ? <Form content={surveyData} /> : null}</div>
                    <div className={styles.right}>
                        <Hot />
                    </div>
                </div>
                {surveyData.surveysetting && Number(surveyData.surveysetting.iscomment) ? (
                    <CommentBox content={surveyData.surveyinfo} />
                ) : null}
            </div>
        ) : null;
    }
}

export default Content;
